/* eslint-disable jsx-a11y/click-events-have-key-events */
import { IconNames } from '@blueprintjs/icons';
import { DropdownMenu } from '@strata/react-dropdown-menu';
import { Icon } from '@strata/react-status-icons';
import * as PropTypes from 'prop-types';
import { useState } from 'react';

import { AddToBatchDialog } from './dialogs/AddToBatchDialog';
import { CreateBatchDialog } from './dialogs/CreateBatchDialog';
import { PreferredPharmacyOfferDialog } from './dialogs/PreferredPharmacyOfferDialog';
import { RemoveFromBatchDialog } from './dialogs/RemoveFromBatchDialog';
import { RemovePreferredPharmacyOfferDialog } from './dialogs/RemovePreferredPharmacyOfferDialog';
import { ReprocessTreatmentDialog } from './dialogs/ReprocessTreatmentDialog';
import { RunRouteSimulatorDialog } from './dialogs/RunRouteSimulatorDialog';

export const UpcomingTreatmentRowMenu = ({
    treatmentId,
    payerId,
    releaseStatus,
    preferredPharmacyOffer = undefined,
    incumbentMapping,
}) => {
    const [showDropdown, setShowDropdown] = useState(false);
    const [showCreateBatchDialog, setShowCreateBatchDialog] = useState(false);
    const [showAddToBatchDialog, setShowAddToBatchDialog] = useState(false);
    const [showReprocessTreatmentDialog, setShowReprocessTreatmentDialog] = useState(false);
    const [showPreferredPharmacyOfferDialog, setShowPreferredPharmacyOfferDialog] = useState(false);
    const [showRemovePreferredPharmacyOfferDialog, setShowRemovePreferredPharmacyOfferDialog] =
        useState(false);
    const [showRunRouteSimulatorDialog, setShowRunRouteSimulatorDialog] = useState(false);
    const [showRemoveFromBatchDialog, setShowRemoveFromBatchDialog] = useState(false);

    const dropdownMenuOptions = [
        {
            text: AddToBatchDialog.Title,
            onItemClick: () => setShowAddToBatchDialog(true),
        },
        {
            text: CreateBatchDialog.Title,
            onItemClick: () => setShowCreateBatchDialog(true),
        },
        ...(releaseStatus === 'BATCHED'
            ? [
                  {
                      text: RemoveFromBatchDialog.Title,
                      onItemClick: () => setShowRemoveFromBatchDialog(true),
                  },
              ]
            : []),
        ...(preferredPharmacyOffer
            ? [
                  {
                      text: RemovePreferredPharmacyOfferDialog.Title,
                      onItemClick: () => setShowRemovePreferredPharmacyOfferDialog(true),
                  },
              ]
            : []),
        {
            text: PreferredPharmacyOfferDialog.Title,
            onItemClick: () => setShowPreferredPharmacyOfferDialog(true),
        },
        {
            text: RunRouteSimulatorDialog.Title,
            onItemClick: () => setShowRunRouteSimulatorDialog(true),
        },
        {
            text: ReprocessTreatmentDialog.Title,
            onItemClick: () => setShowReprocessTreatmentDialog(true),
        },
    ];

    return (
        // eslint-disable-next-line jsx-a11y/no-static-element-interactions
        <div onClick={(e) => e?.stopPropagation()}>
            <CreateBatchDialog
                isOpen={showCreateBatchDialog}
                apiQueryParams={{ treatmentId }}
                onClose={() => setShowCreateBatchDialog(false)}
            />
            <AddToBatchDialog
                isOpen={showAddToBatchDialog}
                apiQueryParams={{ treatmentId }}
                onClose={() => setShowAddToBatchDialog(false)}
            />
            {releaseStatus === 'BATCHED' && (
                <RemoveFromBatchDialog
                    isOpen={showRemoveFromBatchDialog}
                    apiQueryParams={{ treatmentId }}
                    onClose={() => setShowRemoveFromBatchDialog(false)}
                />
            )}
            <ReprocessTreatmentDialog
                isOpen={showReprocessTreatmentDialog}
                apiQueryParams={{ treatmentId }}
                onClose={() => setShowReprocessTreatmentDialog(false)}
            />
            <PreferredPharmacyOfferDialog
                isOpen={showPreferredPharmacyOfferDialog}
                apiQueryParams={{ treatmentId, payerId }}
                treatmentsCount={1}
                onClose={() => setShowPreferredPharmacyOfferDialog(false)}
                incumbentMapping={incumbentMapping}
                staggeredAllowed={false}
            />
            {preferredPharmacyOffer && (
                <RemovePreferredPharmacyOfferDialog
                    isOpen={showRemovePreferredPharmacyOfferDialog}
                    apiQueryParams={{ treatmentId }}
                    onClose={() => setShowRemovePreferredPharmacyOfferDialog(false)}
                />
            )}
            <RunRouteSimulatorDialog
                isOpen={showRunRouteSimulatorDialog}
                apiQueryParams={{ treatmentId }}
                treatmentsCount={1}
                onClose={() => setShowRunRouteSimulatorDialog(false)}
            />
            <DropdownMenu
                isOpen={showDropdown}
                menuItemArray={dropdownMenuOptions}
                onInteraction={(nextOpenState) => {
                    setShowDropdown(nextOpenState);
                }}
            >
                <Icon
                    icon={IconNames.MORE}
                    intent={Icon.Intent.SECONDARY}
                    title="Upcoming Treatment Menu"
                    className="sds_referral-grid__row-menu-button"
                />
            </DropdownMenu>
        </div>
    );
};

UpcomingTreatmentRowMenu.propTypes = {
    treatmentId: PropTypes.string.isRequired,
    payerId: PropTypes.string.isRequired,
    releaseStatus: PropTypes.string.isRequired,
    incumbentMapping: PropTypes.arrayOf(
        PropTypes.shape({
            incumbent_supplier_npi: PropTypes.string,
            treatment_count: PropTypes.number,
        }),
    ).isRequired,
    preferredPharmacyOffer: PropTypes.shape(),
};
